import PropTypes from 'prop-types';

const WEBSITE_HINTS = {
	pending: 'Website wird noch gelesen – erneut testen',
	none: 'Keine Website verfügbar',
	slow: 'Website antwortet zu langsam',
};

const ERROR_LABELS = {
	not_found: 'Empfänger nicht gefunden',
	generation_failed: 'Generierung fehlgeschlagen',
};

/**
 * Result rows of a column test run, labelled with the table rows they were run on.
 */
const PreviewResults = ({ rows, labelFor }) => (
	<>
		{rows.length > 0 && rows.every((row) => row.websiteStatus === 'none') && (
			<p className="text-xs text-caution-700">
				In dieser Auswahl hat kein Empfänger eine lesbare Website. Ohne Website entsteht kein Wert – der
				Ersatzwert greift oder der Empfänger wird übersprungen.
			</p>
		)}
		<div className="border border-bgBase-400 rounded-lg divide-y divide-bgBase-400">
			{rows.map((row) => {
				const id = row.crmContactId ?? row.crmCompanyId;
				return (
					<div key={id} className="px-3 py-2 text-sm">
						<div className="text-xs text-bgBase-800 mb-0.5">{labelFor(row)}</div>
						{row.error ? (
							<span className="text-warning-700">{ERROR_LABELS[row.error] ?? 'Fehler'}</span>
						) : (
							<div className="text-text whitespace-pre-line break-words">
								{row.value ?? (
									<span className="text-warning-700">Kein Wert – wird beim Versand übersprungen</span>
								)}
							</div>
						)}
						<div className="flex gap-2 mt-1">
							{row.usedFallback && (
								<span className="text-[11px] text-bgBase-800">Ersatzwert verwendet</span>
							)}
							{WEBSITE_HINTS[row.websiteStatus] && (
								<span className="text-[11px] text-bgBase-800">{WEBSITE_HINTS[row.websiteStatus]}</span>
							)}
						</div>
					</div>
				);
			})}
		</div>
	</>
);

PreviewResults.propTypes = {
	rows: PropTypes.arrayOf(PropTypes.object).isRequired,
	labelFor: PropTypes.func.isRequired,
};

export default PreviewResults;
